import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, CircularProgress, Typography } from '@mui/material';
import { sendWhatsApp } from '../api/contacts';

interface WhatsAppModalProps {
  open: boolean;
  onClose: () => void;
  contactName: string;
  contactNumber: string;
}

const WhatsAppModal: React.FC<WhatsAppModalProps> = ({ open, onClose, contactName, contactNumber }) => {
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSend = async () => {
    setLoading(true);
    setError('');
    try {
      await sendWhatsApp(contactNumber, message);
      setSuccess(true);
      setTimeout(() => {
        setSuccess(false);
        setMessage('');
        onClose();
      }, 1500);
    } catch (err: any) {
      setError(err.message || 'שגיאה בשליחת ההודעה');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth onClick={(e) => e.stopPropagation()}>
      <DialogTitle>שליחת הודעת וואצאפ ל{contactName}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          מספר {contactNumber}
        </Typography>
        <TextField
          autoFocus
          margin="dense"
          label="הודעה"
          type="text"
          fullWidth
          multiline
          rows={4}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          disabled={loading || success}
        />
        {error && <Typography color="error" variant="body2" sx={{ mt: 1 }}>{error}</Typography>}
        {success && <Typography color="success.main" variant="body2" sx={{ mt: 1 }}>ההודעה נשלחה בהצלחה!</Typography>}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>ביטול</Button>
        <Button onClick={handleSend} color="primary" variant="contained" disabled={loading || !message || success}>
          {loading ? <CircularProgress size={20} /> : 'שליחה'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WhatsAppModal;
